import { PreAlert } from 'components/organisms/PreAlert/PreAlert'
import Layout from 'layout/Layout'

export const PreAlertPage = () => {
    return (
        <Layout>
            <PreAlert />
        </Layout>
    )
}
